import { Box } from '@mui/material';
import useSyncActivePage from '../hooks/useSyncActivePage';
import Navbar from '../Panels/Navbar/Navbar';
import AdminDetailsPanel from './AdminDetailsPanel';
import AdminView from './AdminView';

const Admin = () => {
  useSyncActivePage();

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        position: 'relative',
        minHeight: 0
      }}
    >
      <Navbar />
      <AdminView />
      <AdminDetailsPanel />
    </Box>
  );
};
export default Admin;
